import type { IFilter } from "../models/Filter";
import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type UserInfoDTO = Record<string, JSONValue>;
export const updateInfo = async (data: UserInfoDTO) => {
  return httpRequest.put("/prt/partner", data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/user", { offset, filter });
};

export type UserAdminDTO = Record<string, JSONValue>;
export const updateAdmin = async (data: UserAdminDTO) => {
  return httpRequest.put("/prt/partner/update_admin", data);
};

export const select = async (data: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/user/select", data);
};

export type UserCreateDTO = Record<string, JSONValue>;
export const create = async (data: UserCreateDTO) => {
  return httpRequest.post("/prt/user", data);
};

export type UserUpdateDTO = Record<string, JSONValue>;
export const update = async (id: string, data: UserUpdateDTO) => {
  return httpRequest.put(`/prt/user/${id}`, data);
};

export const del = async (id: string) => {
  return httpRequest.del(`/prt/user/${id}`);
};
